import { createSlice } from '@reduxjs/toolkit';
import LoanOfficersRepository from 'repositories/administrators/LoanOfficersRepository';
import { createRestSlice } from 'utils/RestSlice';

const restSlice = createRestSlice({
  resource: 'loanOfficer',
  pluralResource: 'loanOfficers',
  repository: LoanOfficersRepository,
  slices: ['loadLoanOfficers', 'loadMoreLoanOfficers', 'loadLoanOfficer'],
});

const initialState = {
  ...restSlice.initialState,
};

const administratorsLoanOfficersSlice = createSlice({
  name: 'administratorsLoanOfficers',
  initialState,
  reducers: {
    ...restSlice.reducers,
  },
});

export default administratorsLoanOfficersSlice;
export const administratorsLoanOfficersReducer = administratorsLoanOfficersSlice.reducer;
export const administratorsLoanOfficersHooks = restSlice.hooks(
  administratorsLoanOfficersSlice,
  'administratorsLoanOfficersReducer',
);



// WEBPACK FOOTER //
// ./src/reducers/slices/administrators/loanOfficersSlice.js